import React, { Component } from 'react';

import Content_Header from './content/ContentHeader';
import Content_Donation_Root from '../containers/ContentDonationRoot'; // TODO : 여기
//import Content_Donation_Root from './content/ContentDonationRoot'; 
//import ContentDonationMsg from './content/ContentDonationMsg';
import ContentMain from '../containers/ContentMain'; // TODO : 여기
//import ContentMain from './content/ContentMain'; 

export default class extends Component {
    render() {
        var content = this.props.content;

        function video(src) {
            return (
                <div className="content-video">
                    <iframe src={src} frameBorder="0" width="670" height="376" allowFullScreen></iframe>
                </div>
            );
        }

        function img(src) {
            return <img src={src} alt="" className="content-img"/>
        }


        return (
            <div>
                <div className="content-bg"></div>
                <div className="content">
                    <div className="contains">
                        <div className="content-left">
                            <div className="content-top mobile">
                                <div className="content-main-box">
                                    {(content.isYoutubeUrl) ? video(content.youtubeUrl) : img(content.mainImgUrl)}
                                </div>
                            </div>
                            

                            <Content_Header
                                title={content.title}
                                tagList={content.tagList}
                            />

                            <div className="content-right">
                                <div className="donation-content">
                                    <Organ
                                        type="pc"
                                        organ={content.organ}
                                    />

                                    <Content_Donation_Root
                                        boxStatus={this.props.boxStatus}
                                        donation={content.donation}
                                        selectDonationType={this.props.selectDonationType}
                                        payUrl={this.props.payUrl}
                                    />

                                    {/*<ContentDonationMsg />*/}


                                    <Organ
                                        type="mobile"
                                        organ={content.organ}
                                    />
                                </div>
                            </div>

                            <ContentMain
                                mainImgUrl={content.mainImgUrl}
                                isYoutubeUrl={content.isYoutubeUrl}
                                youtubeUrl={content.youtubeUrl}
                                selectTab={this.props.selectTab}
                                tabMenu={content.tabMenu}
                                content0={content.content0}
                                content1={content.content1}
                                tabMenuClass={content.tabMenuClass}
                            />

                        </div >
                    </div>
                </div>
            </div>
        );
    }
}

class Organ extends Component {
    render() {
        return (
            <div className={"donation-header " + (this.props.type) + ((this.props.organ.isOpen)? "" : " hidden")}>
                <p className="name">{this.props.organ.name}</p>
                <p className="title">{this.props.organ.info}</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Content.js